import { computed, ref, onMounted } from 'vue'
import type { Ref } from 'vue'
import type { WinnerWithPayout } from '@acepoker/contract/acepoker'

interface UsePokerTableTotalPotParams {
  allChipsAreaSelector?: string
  totalPotSelector?: string
  winnersWithPayout: Ref<WinnerWithPayout[]>
  playerStackPosFn: (seatIdx: number) => {
    top: number
    left: number
  }
}
export interface PotTranslate {
  x: number
  y: number
}
interface WinnerDisplayData {
  payout: number
  translate: PotTranslate
}
interface UsePokerTableTotalPot {
  (params: UsePokerTableTotalPotParams): {
    winnersDisplayData: Ref<WinnerDisplayData[]>
  }
}

export const usePokerTableTotalPot: UsePokerTableTotalPot = (data) => {
  const {
    allChipsAreaSelector = '.table__game-zone',
    totalPotSelector = '.table__total-pot',
    playerStackPosFn,
    winnersWithPayout
  } = data

  const allChipsAreaEl = ref<Element | null>()
  const totalPotEl = ref<Element | null>()

  const winnersDisplayData = computed(() => {
    if (!winnersWithPayout.value?.length) {
      return []
    }

    return winnersWithPayout.value.map((winner) => {
      return {
        payout: winner.payout,
        translate: getPotTranslate(playerStackPosFn(winner.seatNo))
      }
    })
  })

  const getPotTranslate = (playerChipBoxPos: { left: number; top: number }): PotTranslate => {
    if (!allChipsAreaEl.value || !totalPotEl.value) {
      return { x: 0, y: 0 }
    }

    const allChipsAreaRect = allChipsAreaEl.value.getBoundingClientRect()
    const totalPotRect = totalPotEl.value.getBoundingClientRect()

    const playerX = allChipsAreaRect.left + (playerChipBoxPos.left / 100) * allChipsAreaRect.width
    const playerY = allChipsAreaRect.top + (playerChipBoxPos.top / 100) * allChipsAreaRect.height

    const deltaX = playerX - (totalPotRect.left + totalPotRect.width / 2)
    const deltaY = playerY - totalPotRect.top

    return { x: deltaX, y: deltaY }
  }

  onMounted(() => {
    allChipsAreaEl.value = document.querySelector(allChipsAreaSelector)
    totalPotEl.value = document.querySelector(totalPotSelector)
  })

  return {
    winnersDisplayData
  }
}
